import { render } from "./SpAlertsLinks.vue?vue&type=template&id=201720c0&scoped=true&ts=true"
import script from "./SpAlertsLinks.vue?vue&type=script&lang=ts"
export * from "./SpAlertsLinks.vue?vue&type=script&lang=ts"

import "./SpAlertsLinks.vue?vue&type=style&index=0&id=201720c0&lang=sass&scoped=true"

import exportComponent from "/home/ec2-user/environment/test_front/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-201720c0"]])

export default __exports__